var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    stroke: "none",
    fill: "#3B4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14999 0.212513L5.36249 4.41251C5.41249 4.46251 5.44783 4.51668 5.46849 4.57501C5.48949 4.63335 5.49999 4.69585 5.49999 4.76251C5.49999 4.82918 5.48949 4.89168 5.46849 4.95001C5.44783 5.00835 5.41249 5.06251 5.36249 5.11251L1.14999 9.32501C1.03333 9.44168 0.887493 9.50001 0.712493 9.50001C0.537493 9.50001 0.387493 9.43751 0.262493 9.31251C0.137493 9.18751 0.0749932 9.04168 0.0749932 8.87501C0.0749932 8.70835 0.137493 8.56251 0.262493 8.43751L3.93749 4.76251L0.262494 1.08751C0.145827 0.970846 0.0874937 0.827179 0.0874937 0.656513C0.0874937 0.485512 0.149994 0.337513 0.274994 0.212513C0.399994 0.0875125 0.545827 0.0250125 0.712494 0.0250126C0.87916 0.0250126 1.02499 0.0875126 1.14999 0.212513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8d4741c7622f6863c7047da5dc698371.svg";
export { ForwardRef as ReactComponent };